<template>
  <button
    @click="toggle"
    type="button"
    class="group mx-auto flex w-max cursor-pointer transition-colors duration-100 ease-out"
    :class="[
      type === 'border'
        ? 'hover:border-gray-medium border border-black px-3.75 py-2'
        : '',
      buttonClass,
    ]"
    :aria-expanded="isExpanded"
  >
    <span
      :class="[
        'text-sm leading-[120%] transition-colors duration-100 ease-out xl:text-[17px] 2xl:text-xl',
        type === 'underline' ? 'underline underline-offset-4' : '',
        buttonColor === 'dark'
          ? 'group-hover:text-gray-medium text-black'
          : 'text-gray-darker group-hover:text-black',
        textClass,
      ]"
    >
      {{ isExpanded ? labelLessText : labelMoreText }}
    </span>
  </button>
</template>

<script setup lang="ts">
interface Props {
  isExpanded?: boolean
  type?: 'border' | 'underline'
  labelMore?: string
  labelLess?: string
  buttonClass?: string
  buttonColor?: 'light' | 'dark'
  textClass?: string
}

const props = withDefaults(defineProps<Props>(), {
  isExpanded: false,
  type: 'underline',
  buttonColor: 'dark',
  buttonClass: '',
  textClass: '',
})

const { t } = useI18n()
const emit = defineEmits<{
  (e: 'update:isExpanded', value: boolean): void
  (e: 'click', event: MouseEvent): void
}>()

const labelMoreText = computed(() => props.labelMore || t('common.show_more'))
const labelLessText = computed(() => props.labelLess || t('common.show_less'))

const toggle = (event: MouseEvent) => {
  emit('update:isExpanded', !props.isExpanded)
  emit('click', event)
}
</script>
